import { NegativeNumberType } from '../types/enums/negative-number-type.enum';

export const NEGATIVE_NUMBER_NEGATIVES_MAPPING: Record<
  NegativeNumberType,
  string
> = {
  [NegativeNumberType.Common]: '',
  [NegativeNumberType.CommonWithWhiteSpace]: ' ',
  [NegativeNumberType.Money]: '(1.1)',
};
